var map = {
	"./bg1.png": 3813,
	"./bg10.png": 4849,
	"./bg2.png": 6462,
	"./bg3.png": 4775,
	"./bg4.png": 9608,
	"./bg5.png": 7473,
	"./bg6.png": 7306,
	"./bg7.png": 4883,
	"./bg8.png": 7220,
	"./bg9.png": 7165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3747;